import { gql } from '@apollo/client';
import { SUBREGION_BASE_FIELDS } from '@/graphql/queries/subregions';
import { RESOURCE_FLEET_FIELDS } from '@/graphql/queries/resources';
import { RESOURCE_REGION_MAPPING_FIELDS } from '@/graphql/queries/resource_region_mappings';

export const GET_COVERAGE_CAPACITY = gql`
    ${SUBREGION_BASE_FIELDS}
    ${RESOURCE_FLEET_FIELDS}
    ${RESOURCE_REGION_MAPPING_FIELDS}

    query GetCoverageCapacity($carrier_id: uuid!, $organization_id: uuid!) {
        subregions(where: { client_id: { _eq: $carrier_id } }, order_by: { name: asc_nulls_last }) {
            ...SubregionBaseFields
        }
        ownZips: subregion_zip_mappings_aggregate(where: { subregion: { client_id: { _eq: $carrier_id } } }) {
            aggregate {
                count(columns: zip, distinct: true)
            }
        }
        resources(where: { client_id: { _eq: $carrier_id } }, order_by: { name: asc_nulls_last }) {
            ...ResourceFleetFields
            subregions {
                ...ResourceRegionMappingFields
            }
        }
        delivery_profiles(where: { organization_id: { _eq: $organization_id } }, order_by: { name: asc_nulls_last }) {
            delivery_profile_id
            name
            auto_assignments(order_by: { shipper: { business_name: asc_nulls_last } }) {
                auto_assign_id
                shipper_id
                shipper {
                    client_id
                    business_name
                }
            }
            subregions(order_by: { name: asc_nulls_last }) {
                subregion_id
                name
                zips_aggregate {
                    aggregate {
                        count
                    }
                }
                claimedZips: zips_aggregate(
                    where: { same_zip_mappings: { subregion: { client_id: { _eq: $carrier_id } } } }
                ) {
                    aggregate {
                        count
                    }
                }
                carriers(
                    where: {
                        _or: [
                            { carrier_id: { _eq: $carrier_id } }
                            { middle_mile_carrier_id: { _eq: $carrier_id } }
                            { warehouse_carrier_id: { _eq: $carrier_id } }
                        ]
                    }
                ) {
                    mapping_id
                    carrier_id
                    middle_mile_carrier_id
                    warehouse_carrier_id
                    is_primary
                }
            }
        }
    }
`;
